import { createConnectQueryKey, useMutation } from '@connectrpc/connect-query'
import { useQueryClient } from '@tanstack/react-query'

import { toaster } from '@enechain/ecloud-designsystem'

import { createApiKey } from '~/gen/proto/bff/v1/admin-BffAdminService_connectquery'
import {
  BffAdminService,
  CreateApiKeyResponse,
} from '~/gen/proto/bff/v1/admin_pb'

export function useCreateApiKey(
  onSuccess: (response: CreateApiKeyResponse) => void,
): ReturnType<typeof useMutation> {
  const queryClient = useQueryClient()
  return useMutation(createApiKey, {
    onError: (error) => {
      toaster.create({
        title: error.message,
        type: 'error',
      })
    },
    onSuccess: (response) => {
      void queryClient.invalidateQueries({
        queryKey: createConnectQueryKey({
          schema: BffAdminService.method.listApiKeys,
          cardinality: 'finite',
        }),
      })
      onSuccess(response)
    },
  })
}
